import { Box, Checkbox, TableCell, TableRow, Tooltip } from '@mui/material';
import React from 'react'
import AuditPopover from '../../../shared_elements/components/popover';
import { AttachFile } from '@mui/icons-material';
import RestoreIcon from '@mui/icons-material/Restore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LessMoreComp from '../../../shared_elements/components/CustomLessMoreComp';
import moment from 'moment';
import { trackActivity } from '../../../utils/mixpanel';
import { PermissionWrapper } from '../../../wrappers';
import UploadingIcon from '../../../shared_elements/components/UploadingIcon';

const ExpiryAlertList = ({toggleBulkOps, bulk, item, onView, onEdit, onDelete, viewFile, viewRevisonHistory, viewFileStatus, uploadedFileData, slug}) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Expiry Alert Notification List`, page_type: page_type, })
    }

    return (
        <TableRow>
            <TableCell className="table-actions-list">
                <Box className="table-icon-container">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "expiry_alert", operationType: ['D'] }}>
                        <Checkbox onChange={(e) => toggleBulkOps(e.target.checked, "single", item)} checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} size='small' color='primary' sx={{ cursor: "pointer" }} />
                    </PermissionWrapper>
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <Tooltip title="Revision History">
                        <RestoreIcon className='revision-history' color="primary" fontSize='small' onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon'); }} />
                    </Tooltip>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "expiry_alert", operationType: ['R'] }}>
                        <Tooltip title="View">
                            <VisibilityIcon fontSize='small' color='primary' sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('ViewIcon'); }} />
                        </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "expiry_alert", operationType: ['U'] }}>
                        <Tooltip title="Edit">
                            <EditIcon fontSize='small' color='primary' sx={{ cursor: 'pointer' }} onClick={() => { onEdit(); handleItemClicked('EditIcon') }} />
                        </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "expiry_alert", operationType: ['D'] }}>
                    <Tooltip title="Delete">
                        <DeleteIcon fontSize='small' color='error' sx={{ cursor: 'pointer' }} onClick={() => {onDelete(); handleItemClicked('DeleteIcon');}} />
                    </Tooltip>
                    </PermissionWrapper>

                    <Tooltip title="Attached File(s)">
                        {
                            item?.attachments?.length > 0 && (
                                <Tooltip title="Attached File(s)">
                                    <Box className="attachment-container">
                                        <AttachFile fontSize="small" color="primary" onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                        <Box className="attachment-count">
                                            ({item.attachments.length})
                                        </Box>
                                    </Box>
                                </Tooltip>
                            )
                        }
                    </Tooltip>
                    { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                </Box>
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.name?.length > 50 ? "200px" : '' }}><LessMoreComp name={item?.name} lessMr='name' /></div></TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.frequency_to_notify ? item?.frequency_to_notify : "--"}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.module?.name ? item?.module?.name : "--"}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.module_fields?.field_name ? item?.module_fields?.field_name : "--"}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.status !== undefined ? item.status ? "Active" : "Inactive" : "--"}</TableCell>
            <TableCell sx={{width: '200px', cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>
                <div style={{ width: item?.sparta_users?.length > 50 ? "200px" : "" }}> <LessMoreComp name={item?.sparta_users?.map(user => user?.email).join(", ")} lessMr='sparta_users' /> </div>
            </TableCell>
            <TableCell sx={{width: '200px', cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>
                <div style={{ width: item?.non_sparta_users?.length > 50 ? "200px" : "" }}> <LessMoreComp name={item?.non_sparta_users?.map(user => user.email).join(", ")} lessMr='non_sparta_users' /></div>
            </TableCell>
            <TableCell sx={{width: '200px', cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.description?.length > 50 ? "200px" : '' }}><LessMoreComp name={item?.description} lessMr='description' /></div></TableCell>
        </TableRow>
    )
}

export default ExpiryAlertList;